exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ng-valid[required], .ng-valid.required  {\n  border-left: 5px solid #42A948; /* green */\n}\n\n.ng-invalid:not(form)  {\n  border-left: 5px solid #a94442; /* red */\n}\n\n#remark{\n  width: 100%;\n  height: 30px;\n}\n\n.container{\n  width: 80%;\n}\n\n#contact-shortly {\n  text-align: center;\n  font-size: 1.5em; \n  color: seagreen;\n}\n\n\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/forge/dev-client-app.instaveritas.com/releases/20231127121751/src/app/form/revert-form/revert-form.component.css
// module id = ../../../../../src/app/form/revert-form/revert-form.component.css
// module chunks = 0